import { Stack, Typography } from '@montugroup/design-system';

export function HeadingSection() {
  return (
    <Stack marginBottom={6} gap={1}>
      <Typography
        component="h1"
        sx={(theme) => ({ color: theme.palette.primary.main, fontSize: theme.typography.h5.fontSize })}
      >
        Medicine information
      </Typography>
      <Typography variant="body2" sx={(theme) => ({ color: theme.palette.primary.main })}>
        Discover details about the products you&apos;ve been prescribed
      </Typography>
    </Stack>
  );
}

export default HeadingSection;
